import {CheckoutModel} from '../models/checkout/Checkout.model';

export const isPartiallyPaid = (checkout: CheckoutModel) => Boolean(checkout.payLater?.total.amount);
export const hasFreeTrial = (checkout: CheckoutModel, supportFreeTrialLineItems: boolean) =>
  Boolean(supportFreeTrialLineItems && checkout.payAfterFreeTrial?.total.amount);

export const getTotal = (checkout: CheckoutModel, supportFreeTrialLineItems: boolean) =>
  !isPartiallyPaid(checkout) && !hasFreeTrial(checkout, supportFreeTrialLineItems)
    ? checkout.payNowTotalAfterGiftCard.formattedAmount
    : checkout.totalAfterGiftCard!.formattedAmount;
